import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import {
    Box,
    Button,
    Alert,
    AlertTitle,
    List,
    ListItem,
    ListItemText,
} from "@mui/material/";
import { useTheme } from "@mui/material/styles";
import AppModal from "../common/components/AppModal";
import styles from "./styles";

export default ({ alertModal, setAlertModal, duplicatedAssignments }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const sxStyles = styles(theme);

    const { auditAssignments } = useSelector((state) => state);

    const closeAlert = () => setAlertModal(false);

    return (
        <AppModal
            hasTitle={false}
            fullScreen={false}
            fullWidth={false}
            size="md"
            isVisible={alertModal}
            onClose={closeAlert}
        >
            <Box sx={sxStyles.alertWrapper}>
                <Alert severity="warning">
                    <AlertTitle>{t("duplicateAuditsTitle")}</AlertTitle>
                    <p>{t("messages.duplicatedAudit")}</p>
                    <List>
                        {duplicatedAssignments.map((item) => {
                            const index =
                                auditAssignments.byId[item.assignmentId];
                            const assignment = auditAssignments.data[index];
                            return (
                                <ListItem
                                    sx={{ padding: 0 }}
                                    key={item.assignmentId}
                                >
                                    <ListItemText
                                        primary={
                                            assignment.auditLocation.audit.name
                                        }
                                    />
                                </ListItem>
                            );
                        })}
                    </List>
                    <p>{t("messages.duplicatedAuditWarning")}</p>
                </Alert>

                <Button
                    variant="outlined"
                    onClick={closeAlert}
                    sx={sxStyles.closeAlert}
                >
                    {t("close").toUpperCase()}
                </Button>
            </Box>
        </AppModal>
    );
};
